<template>
	<div class="Seek_container">
		<div class="Seek_head">
			<div @click="Lease" class="Lease">租赁设备</div>
			<div @click="PublishCollect" class="PublishCollect">发布招领</div>
		</div>
		<div class="Seek_content">
			<div class="Seek_people">
				<div class="Seek_people_title">紧急寻人</div>
				<div class="Seek_people_all">
					<div v-if="peoplelist.length!=0" class="Seek_people_content">
						<div :style="'background: url('+item.trackimg+') center center no-repeat;background-size: cover;'" v-for="item in peoplelist" class="Seek_people_list" @click="peopleCli(item)">
							<div class="Seek_people_list_bottom" v-if="item.tracksex==2">
								{{item.trackname}}（女） {{item.trackage}}岁
							</div>
							<div class="Seek_people_list_bottom" v-if="item.tracksex==1">
								{{item.trackname}}（男） {{item.trackage}}岁
							</div>
						</div>
					</div>
					<div v-if="peoplelist.length==0" class="Seek_people_contentt">
						暂无
					</div>
				</div>
			</div>
			<div class="Seek_matter">
				<div class="Seek_matter_title">失物招领</div>
				<div class="Seek_matter_all">
					<div v-if="matterlist.length!=0" class="Seek_matter_list" v-for="(item,index) in matterlist">
						<div class="Seek_matter_list_top">
							<div class="Seek_matter_list_top_left">
								<img draggable="false" :src="item.avatarurl" />
							</div>
							<div class="Seek_matter_list_top_right">
								<div>{{item.nickname}}</div>
								<div>{{item.createtime}}</div>
							</div>
							<div class="Seek_matter_list_top_type">
								<div v-if="item.losttype=='lostfound'">寻找失主</div>
								<div v-if="item.losttype=='lossgoods'">物品丢失</div>
							</div>
						</div>
						<div :class="toBottomIndex==index?'Seek_matter_list_text_bottom':'Seek_matter_list_text'">{{item.remarks}}</div>
						<div class="Seek_matter_list_bottom" v-if="item.remarks.length>50">
							<img v-if="toBottomIndex!=index" @click="Seek_matter_tobottom(index)" src="../assets/toBottom.png"/>
							<img v-else="" @click="Seek_matter_totop" src="../assets/toTop.png"/>
						</div>
						<div class="Seek_matter_list_address">
							<img draggable="false" src="../assets/address.png" />
							<div>{{item.lostaddress}}</div>
						</div>
						<div class="Seek_matter_list_img">
							<div class="Seek_matter_list_img_all">
								<div v-if="item.image" class="Seek_matter_list_img_list" :style="'background: url('+item.image+') center center no-repeat;background-size: cover;'">

								</div>
							</div>
						</div>
					</div>
					<div v-if="matterlist.length==0" class="Seek_matter_listt">
						暂无
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Seek',
		data() {
			return {
				baseUrl: "",
				peoplelist: [],
				matterlist: [],
				loading: true,
				loadingEnd: false,
				baseUrll: "",
				baseUrlOne: "",
				toBottomIndex:-1
			}
		},
		methods: {
			Seek_matter_totop(){
				var that=this;
				that.toBottomIndex=-1;
			},
			Seek_matter_tobottom(index){
				var that=this;
				that.toBottomIndex=index;
			},
			ToHome() {
				var that = this;
				that.$router.back(-1)
			},
			peopleCli(item) {
				var that = this;
				sessionStorage.setItem('trackid', item.trackid)
				sessionStorage.setItem('Seek', 'seek')
				that.$router.push({
					name: 'SeekDetails'
				})
			},
			PublishCollect() {
				var that = this;
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "POST",
					url: that.baseUrll + "/tickets/tickets/ajax?ugi=loginUgi&action=loginInfo",
					dataType: "json",
					async: true,
					data: {

					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							that.$router.push({
								name: 'PublishCollect'
							});
						} else if(data.code == 'A00004') {
							sessionStorage.setItem('landType', 'PublishCollect')
							that.$router.push({
								name: 'CenterLand'
							});
						}
					}
				});
			},
			Lease() {
				var that = this;
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "POST",
					url: that.baseUrll + "/tickets/tickets/ajax?ugi=loginUgi&action=loginInfo",
					dataType: "json",
					async: true,
					data: {

					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							that.$router.push({
								name: 'Lease'
							});
						} else if(data.code == 'A00004') {
							sessionStorage.setItem('landType', 'Lease')
							that.$router.push({
								name: 'CenterLand'
							});
						}
					}
				});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
				var baseUrll = "http://tickets.xs.weapi.org";
				var baseUrlOne = "http://xs.weapi.org";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
				var baseUrll = "http://tickets.xs.weapi.org";
				var baseUrlOne = "http://xs.weapi.org";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
				var baseUrll = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.baseUrll = baseUrll;
			that.baseUrlOne = baseUrlOne;

			wclient.crossdomain = true;
							wclient.view.showLoading();
							wclient.ajax({
								type: "GET",
								url: that.baseUrl + "?ugi=tracking&action=trackingList",
								dataType: "json",
								async: true,
								data: {

								},
								success: function(data) {
									if(data.code == 'A00006') {
										wclient.view.hideLoading();
										that.peoplelist = data.list;
									}
								}
							});
							wclient.ajax({
								type: "GET",
								url: that.baseUrl + "?ugi=lostarticle&action=lostarticleList",
								dataType: "json",
								async: true,
								data: {

								},
								success: function(data) {
									if(data.code == 'A00006') {
										wclient.view.hideLoading();
										that.matterlist = data.list;
									}
								}
							});
			// if(localStorage.getItem('access_token') == null) {
			// 	sessionStorage.setItem('token_type', 'seek')
			// 	that.$router.push({
			// 		name: 'Logo'
			// 	})
			// } else {
			// 	$.ajax({
			// 		type: "GET",
			// 		url: that.baseUrlOne + "/ajax?ugi=loginUgi&action=logininfo",
			// 		dataType: "json",
			// 		async: true,
			// 		data: {
			// 			access_token: localStorage.getItem('access_token')
			// 		},
			// 		success: function(res) {
			// 			if(res.code == 'A00006') {
			// 				wclient.crossdomain = true;
			// 				wclient.view.showLoading();
			// 				wclient.ajax({
			// 					type: "GET",
			// 					url: that.baseUrl + "?ugi=tracking&action=trackingList",
			// 					dataType: "json",
			// 					async: true,
			// 					data: {

			// 					},
			// 					success: function(data) {
			// 						if(data.code == 'A00006') {
			// 							wclient.view.hideLoading();
			// 							that.peoplelist = data.list;
			// 						}
			// 					}
			// 				});
			// 				wclient.ajax({
			// 					type: "GET",
			// 					url: that.baseUrl + "?ugi=lostarticle&action=lostarticleList",
			// 					dataType: "json",
			// 					async: true,
			// 					data: {

			// 					},
			// 					success: function(data) {
			// 						if(data.code == 'A00006') {
			// 							wclient.view.hideLoading();
			// 							that.matterlist = data.list;
			// 						}
			// 					}
			// 				});
			// 			} else {
			// 				sessionStorage.setItem('token_type', 'seek')
			// 				that.$router.push({
			// 					name: 'Logo'
			// 				})
			// 			}
			// 		}
			// 	});
			// }
		}
	}
</script>

<style scoped>
	.Seek_container {
		width: 100%;
		height: 100vh;
		margin: 0 auto;
		position: relative;
		-moz-user-select: none;
		-webkit-user-select: none;
		user-select: none;
		background: white;
		-webkit-overflow-scrolling: touch;
	}
	
	.Seek_container>img {
		position: absolute;
		top: 50px;
		left: 5%;
		width: 6%;
		z-index: 999;
	}
	
	.Seek_head {
		width: 90%;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}
	
	.PublishCollect {
		width: 49%;
		height: 85px;
		background: url(../assets/PublishCollect.png) center center;
		background-size: cover;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 17px;
	}
	
	.Lease {
		width: 49%;
		height: 85px;
		background: url(../assets/Lease.png) center center;
		background-size: cover;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 17px;
	}
	
	.Seek_top {
		width: 90%;
		padding: 20px 5%;
	}
	
	.Seek_top div:nth-child(1) {
		text-align: center;
		color: white;
		font-size: 45px;
		line-height: 130px;
	}
	
	.Seek_content {
		width: 100%;
		background: white;
		overflow-y: auto;
		-ms-overflow-style: none;
		padding-bottom: 1vh;
	}
	
	.Seek_people {
		width: 90%;
		margin: 0 auto;
	}
	
	.Seek_people_title {
		width: 100%;
		color: #000000;
		letter-spacing: 2px;
		font-size: 18px;
		line-height: 50px;
		font-weight: 600;
	}
	
	.Seek_people_all {
		width: 100%;
		overflow: hidden;
	}
	
	.Seek_people_content {
		display: -webkit-box;
		display: -ms-flexbox;
		justify-content: flex-start;
		overflow-x: auto;
		padding: 0 3% 0 0;
		-ms-overflow-style: none;
	}
	
	.Seek_people_contentt {
		width: 100%;
		height: 100px;
		font-size: 18px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.Seek_people_list {
		width: 48%;
		height: 150px;
		position: relative;
		margin-right: 10px;
	}
	
	.Seek_people_list_bottom {
		width: 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		color: white;
		font-size: 14px;
		line-height: 35px;
		text-indent: 10px;
	}
	
	.Seek_matter {
		width: 90%;
		margin: 0 auto;
	}
	
	.Seek_matter_title {
		width: 100%;
		color: #000000;
		letter-spacing: 2px;
		font-size: 18px;
		line-height: 50px;
		font-weight: 600;
	}
	
	.Seek_matter_list {
		width: 100%;
		padding: 20px 0;
		border-bottom: 2px solid #F5F5F5;
	}
	
	.Seek_matter_listt {
		width: 100%;
		height: 100px;
		font-size: 18px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.Seek_matter_list_top {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.Seek_matter_list_top_left {
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.Seek_matter_list_top_left img {
		width: 100%;
	}
	
	.Seek_matter_list_top_right {
		width: 60%;
		line-height: 25px;
	}
	
	.Seek_matter_list_top_right div:nth-child(1) {
		font-size: 16px;
		color: #232323;
	}
	
	.Seek_matter_list_top_right div:nth-child(2) {
		font-size: 14px;
		color: #ABABAB;
	}
	
	.Seek_matter_list_top_type {
		font-size: 14px;
		color: #CE0000;
	}
	
	.Seek_matter_list_text {
		width: 100%;
		color: #232323;
		font-size: 15px;
		margin: 20px 0;
		line-height: 18px;
		letter-spacing: 2px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}
	.Seek_matter_list_text_bottom {
		width: 100%;
		color: #232323;
		font-size: 15px;
		margin: 20px 0;
		line-height: 18px;
		letter-spacing: 2px;
	}
	
	.Seek_matter_list_address {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.Seek_matter_list_address img {
		width: 15px;
		height: 20px;
	}
	
	.Seek_matter_list_address div {
		margin-left: 10px;
		font-size: 14px;
		color: #5D5D5D;
	}
	
	.Seek_matter_list_img {
		width: 100%;
		overflow: hidden;
		margin-top: 15px;
	}
	
	.Seek_matter_list_img_all {
		display: -webkit-box;
		display: -ms-flexbox;
		justify-content: flex-start;
		overflow-x: auto;
		padding: 0 3% 0 0;
		-ms-overflow-style: none;
	}
	
	.Seek_matter_list_img_list {
		width: 40%;
		height: 120px;
		margin-right: 20px;
	}
	
	.Seek_matter_list_img_list img {
		width: 100%;
	}
	.Seek_matter_list_bottom{
		width: 100%;
	}
	.Seek_matter_list_bottom img{
		width: 5%;
		margin: 10px auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/Seek.vue